import React from 'react';
import { IOSShadow } from './IOSShadow';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
}
export function GlassCard({
  children,
  className = ''
}: GlassCardProps) {
  return <IOSShadow intensity="light" data-id="element-30">
      <div className={`rounded-2xl bg-white/70 backdrop-blur-md border border-white/40 p-4 ${className}`} data-id="element-31">
        {children}
      </div>
    </IOSShadow>;
}